"use strict";
const READ_ONLY_REDIRECT_CASES = [
  {
    fromRegex: idPathRegex("email"),
    toSegment: "readonly_emails"
  },
  {
    fromRegex: idPathRegex("factor_invoices"),
    toSegment: "readonly_factor_invoices"
  },
  {
    fromRegex: idPathRegex("index-document-batches"),
    toSegment: "readonly_document_batches"
  }
];
export function readOnlyRedirect(path) {
  for (const { fromRegex, toSegment } of READ_ONLY_REDIRECT_CASES) {
    const match = path.match(fromRegex);
    if (match) {
      const id = match.groups.id;
      return `/${toSegment}/${id}`;
    }
  }
  return null;
}
function idPathRegex(segment) {
  return new RegExp(`\\/${segment}\\/(?<id>\\d+)`);
}
